(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-endless"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
	constructor() {
		super();
		
		this.productsGrid 	= document.querySelector('#product-grid');
		this.loading 		= this.querySelector('.loading-overlay');
		this.seo 		= document.querySelector("#section__collection-seo");

		this.querySelector('a').remove();

		if ( !this.productsGrid ) return;
		
		if( this.seo ) this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
		
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) {
				return;
			}
			this.loading.classList.remove('dn');

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const products = html.querySelector('#product-grid');
					const infinite = html.querySelector('infinite-scroll');

					if ( products && products.innerHTML.trim().length ) {
						this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
					}

					if( infinite ){
						this.dataset.url = infinite.dataset.url;
					}else{
						observer.unobserve(this);
						if( this.seo ) this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
						
					}
					this.loading.classList.add('dn');
				})
				.catch(e => {
					this.loading.classList.add('dn');
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
	}
}
customElements.define('infinite-scroll', InfiniteScroll);

document.addEventListener('DOMContentLoaded', function () {
	const url = window.location.href;
	if (url.includes("/collections")) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = urlParams.get('page');

    if (currentPage && parseInt(currentPage) > 1) {
      const newUrl = window.location.href.split('?')[0];
      window.location.href = newUrl; 
    }
	}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-season"] && !window.DesignMode) return;
  try {
    
  class InstantPagesLoad extends HTMLElement {
    constructor() {
        super();
        
        // Cache DOM elements
        this.collectionsGrid = document.querySelector('#collection-grid');
        this.loading = this.querySelector('.loading-overlay');
        this.seo = document.querySelector("#section__collection-seo");
        
        // Initialize state
        this.seasonInUrl = this.extractSeasonFromUrl();
        
        // Remove the default link
        const defaultLink = this.querySelector('a');
        if (defaultLink) defaultLink.remove();
        
        if (!this.collectionsGrid) return;
        
        if (this.seo) {
            this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
        }
        
        this.loadAllPages(this.dataset.url);
    }
    
    extractSeasonFromUrl() {
        const url = window.location.href.toLowerCase();
        const hash = window.location.hash.replace('#', '');
        const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];
        
        // Check hash first, then URL path
        if (hash && seasons.includes(hash)) {
            return hash;
        }
        
        return seasons.find(season => url.includes(season)) || '';
    }
    
    async loadAllPages(url) {
        if (!url) return;
        
        this.loading.classList.remove('dn');
        
        try {
            while (url) {
                const response = await fetch(url);
                const text = await response.text();
                const html = document.createElement('div');
                html.innerHTML = text;
                
                const collections = html.querySelector('#collection-grid');
                const nextPage = html.querySelector('instant-pages-load');
                
                if (collections) {
                    this.appendNewCollections(collections);
                }
                
                url = nextPage ? nextPage.dataset.url : null;
            }
        } catch (error) {
            console.error("Error loading pages:", error);
        } finally {
            this.loading.classList.add('dn');
            if (this.seo) {
                this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
            }
            // Only initialize filtering once globally
            InstantPagesLoad.initializeGlobalFiltering();
        }
    }
    
    appendNewCollections(collections) {
        collections.querySelectorAll(".collection__item").forEach(newItem => {
            const existingItem = this.collectionsGrid.querySelector(`[data-id="${newItem.dataset.id}"]`);
            if (!existingItem) {
                this.collectionsGrid.appendChild(newItem.cloneNode(true));
            }
        });
    }
    
    // Static method to ensure filtering is only initialized once
    static initializeGlobalFiltering() {
        // Use a static flag to ensure this only runs once
        if (InstantPagesLoad.filteringInitialized) return;
        
        InstantPagesLoad.filteringInitialized = true;
        
        const seasonInUrl = InstantPagesLoad.extractSeasonFromUrl();
        console.log("Initializing season filtering for:", seasonInUrl);
        
        InstantPagesLoad.addSeasonFilterListeners();
        InstantPagesLoad.preSelectSeason(seasonInUrl);
    }
    
    static extractSeasonFromUrl() {
        const url = window.location.href.toLowerCase();
        const hash = window.location.hash.replace('#', '');
        const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];
        
        // Check hash first, then URL path
        if (hash && seasons.includes(hash)) {
            return hash;
        }
        
        return seasons.find(season => url.includes(season)) || '';
    }
    
    static addSeasonFilterListeners() {
        const seasonFilterTabs = document.querySelectorAll(".collection-seasons__container .season.tab a");
        
        seasonFilterTabs.forEach(filter => {
            filter.addEventListener("click", (e) => InstantPagesLoad.handleSeasonClick(e, filter));
        });
    }
    
    static handleSeasonClick(e, filter) {
        e.preventDefault();
        
        // Prevent rapid clicking
        if (filter.dataset.processing) return;
        filter.dataset.processing = 'true';
        
        setTimeout(() => {
            delete filter.dataset.processing;
        }, 300);
        
        // Don't process if already active
        if (filter.parentElement.classList.contains("active")) {
            return;
        }
        
        InstantPagesLoad.updateActiveTab(filter);
        InstantPagesLoad.applySeasonFilter(filter.getAttribute("data-season"));
        InstantPagesLoad.updateUrlHash(filter.getAttribute("data-season"));
    }
    
    static updateActiveTab(activeFilter) {
        const seasonFilterTabs = document.querySelectorAll(".collection-seasons__container .season.tab");
        
        seasonFilterTabs.forEach(tab => {
            tab.classList.remove("active");
        });
        
        activeFilter.parentElement.classList.add("active");
    }
    
    static applySeasonFilter(selectedSeason) {
        const collections = document.querySelectorAll(".collection__item");
        
        collections.forEach(collection => {
            const itemSeasons = collection.getAttribute("data-item-season");
            if (!itemSeasons) return;
            
            const seasonList = itemSeasons.toLowerCase().split(" - ");
            const shouldShow = selectedSeason === "all" || seasonList.includes(selectedSeason);
            
            if (shouldShow) {
                collection.classList.remove("dn");
                collection.classList.add("db");
            } else {
                collection.classList.remove("db");
                collection.classList.add("dn");
            }
        });
        
        // Trigger a custom event for other components that might need to know
        document.dispatchEvent(new CustomEvent('seasonFilterChanged', {
            detail: { season: selectedSeason }
        }));
    }
    
    static updateUrlHash(season) {
        if (season === 'all') {
            // Remove hash for 'all'
            if (window.location.hash) {
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }
        } else {
            // Update hash for specific season
            history.replaceState(null, null, `${window.location.pathname}${window.location.search}#${season}`);
        }
    }
    
    static preSelectSeason(seasonInUrl) {
        if (!seasonInUrl) return;
        
        const seasonFilterTabs = document.querySelectorAll(".collection-seasons__container .season.tab a");
        const targetFilter = Array.from(seasonFilterTabs).find(filter => 
            filter.getAttribute("data-season") === seasonInUrl
        );
        
        if (targetFilter) {
            // Use a small delay to ensure DOM is ready
            setTimeout(() => {
                targetFilter.click();
            }, 100);
        }
    }
}
customElements.define('instant-pages-load', InstantPagesLoad);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stock-photos"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
	constructor() {
		super();
		
		this.productsGrid 	= document.querySelector('#product-grid');
		this.loading 		= this.querySelector('.loading-overlay');

		this.querySelector('a').remove();

		if ( !this.productsGrid ) return;

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) {
				return;
			}
			this.loading.classList.remove('dn');

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const products = html.querySelector('#product-grid');
					const infinite = html.querySelector('infinite-scroll');

					if ( products && products.innerHTML.trim().length ) {
						this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
					}

					if( infinite ){
						this.dataset.url = infinite.dataset.url;
					}else{
						observer.unobserve(this);
					}
					this.loading.classList.add('dn');
				})
				.catch(e => {
					this.loading.classList.add('dn');
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}
customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();
})();
